import { POST_KEY } from '../../constants'
import { appMessages } from '../../../../../messages'
import createValidationElementUtil from '../../../../redux/utils/create-validation-element'

const ENVIRONMENT_WEBSITE_URL = 'https://www.gymaholic.co'

/**
 * Used to create a Regular Expression to match an url.
 * @private
 * @type {string}
 */
const URL_CONTENT = '((?:(?:https?:\\/\\/)?(?:(?:(?:\\d+\\.){3}\\d+)|(?:[\\w\\-\\.\\:@]+\\.\\w{2,}))(?:[\\/:?][\\w\\-\\/\\.\\?=&\\(\\)#%]*))|(?:https?:\\/\\/[\\w\\-\\.\\:@]+\\.\\w{2,})|(?:(?:[\\w\\-]+\\.){1,}\\w{2,}))'

function urlPostValidator (value) {
  value = value.toLowerCase()
  if (
    value.startsWith(ENVIRONMENT_WEBSITE_URL) &&
    (
      new RegExp(URL_CONTENT)
    ).test(value)
  ) {
    return true
  }
  return createValidationElementUtil(
    POST_KEY.URL,
    appMessages.invalid,
    { name: POST_KEY.URL }
  )
}

export {
  urlPostValidator
}
